import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import idFlag from '../assets/images/flags/id.jpg';
import enFlag from '../assets/images/flags/en.jpg';

const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    useEffect(() => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage && savedLanguage !== i18n.language) {
            i18n.changeLanguage(savedLanguage);
            setCurrentLanguage(savedLanguage);
        };
    }, [i18n]);
    
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            };
        };
        
        document.addEventListener('mousedown', handleOutsideClick);
        
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem('language', lang);
        setCurrentLanguage(lang);
        setIsDropdownOpen(false);
    };
    
    const languages = [
        { code: 'id', name: t('languages.indonesian'), flag: idFlag },
        { code: 'en', name: t('languages.english'), flag: enFlag },
    ];
    
    const filteredLanguages = languages.filter(
        (lang) => lang.code !== currentLanguage
    );
    
    return (
        <div className='relative' ref={dropdownRef}>
            <button
                className='flex h-10 p-2 items-center rounded-full bg-white hover:outline-none hover:bg-platinum focus:outline-none focus:bg-grayX11 text-sm text-black font-medium'
                type='button'
                onClick={() => setIsDropdownOpen((prev) => !prev)}
            >
                <img
                    className='w-6 h-6 mr-2 rounded-full'
                    src={languages.find((lang) => lang.code === currentLanguage)?.flag}
                    alt={currentLanguage}
                />
                {languages.find((lang) => lang.code === currentLanguage)?.name}
                {isDropdownOpen ? (
                    <ExpandLessIcon className='ml-1 text-black' />
                ) : (
                    <ExpandMoreIcon className='ml-1 text-black' />
                )}
            </button>
            
            {/* Dropdown Menu */}
            {isDropdownOpen && (
                <div className='absolute mt-2 w-max right-0 rounded-full bg-white'>
                    {filteredLanguages.map((lang) => (
                        <button
                            className='flex w-full p-2 items-center rounded-full text-sm font-medium hover:outline-none hover:bg-platinum focus:outline-none focus:bg-grayX11'
                            key={lang.code}
                            onClick={() => changeLanguage(lang.code)}
                        >
                            <img
                                className='w-6 h-6 mr-2 rounded-full'
                                src={lang.flag}
                                alt={lang.name}
                            />
                            {lang.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
